<template>
  <div class="app-contract-id">
    {{ currentCustomer.contract.contractId }}
  </div>
</template>
<script>

import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import transaction from '@/mixins/transaction'

export default {
  name: 'ContractId',
  data () {
    return {
      currentCustomer: {
        contract: {
          contractId: ''
        }
      }
    }
  },
  props: {
    url: {
      type: String,
      default: '/'
    }
  },
  mixins: [
    transaction('contractId')
  ],
  apollo: {
    currentCustomer: function () {
      return wrapQuery(gql`query contractId {
        currentCustomer {
          contract {
            contractId
          }
        }
      }`, this, 'currentCustomer')
    }
  }
}
</script>
